import cn from 'classnames';
import type { ComponentProps } from 'react';
import { BaseDatePicker, type DatePickerDateType, useGetDatePickerFormat, useIsTwelveHourFormat } from '../base-picker';
import styles from './time-picker.module.css';

export type TimePickerProperties<ValueType = DatePickerDateType, IsMultiple extends boolean = false> = {
  fullWidth?: boolean;
} & ComponentProps<typeof BaseDatePicker.TimePicker<ValueType, IsMultiple>>;

const TimePicker = <ValueType = DatePickerDateType, IsMultiple extends boolean = false>({
  className,
  fullWidth,
  ...props
}: TimePickerProperties<ValueType, IsMultiple>) => {
  const getDatePickerFormat = useGetDatePickerFormat();
  const isTwelveHourFormat = useIsTwelveHourFormat();

  return (
    <BaseDatePicker.TimePicker<ValueType, IsMultiple>
      className={cn(className, { [styles['full-width'] ?? '']: fullWidth })}
      format={getDatePickerFormat('defaultTimeFormat')}
      showSecond={false}
      size="large"
      use12Hours={isTwelveHourFormat}
      {...props}
    />
  );
};

export default TimePicker;
